<template>
  <component
    v-bind="$attrs"
    :is="componentName"
    :to="to"
    :tag="tag"
    :class="classList"
    class="app-link"
    @click="$emit('click', $event)"
  >
    <slot>
      {{ label }}
    </slot>
  </component>
</template>

<script>
export default {
  name: 'AppLink',
  inheritAttrs: false,
  props: {
    label: String,
    tag: {
      type: String,
    },
    to: [String, Object],
    active: Boolean,
    back: Boolean,
    bordered: Boolean,
  },
  computed: {
    componentName() {
      return this.to ? 'router-link' : this.tag || 'div';
    },
    classList() {
      return {
        'app-link--active': this.active,
        'app-link--back': this.back,
        'app-link--bordered': this.bordered,
      };
    },
  },
};
</script>

<style lang="scss">
.app-link {
  $root: &;

  display: inline-block;
  font-size: rem(13);
  font-weight: normal;
  line-height: 130%;
  color: $color-black;
  text-decoration: none;
  cursor: pointer;
  opacity: 0.4;
  transition: all 0.15s linear;

  &:hover,
  &--active,
  &.router-exact-link-active {
    opacity: 1;

    &#{$root}--bordered {
      border-bottom-color: $current-color;
    }
  }

  &--active,
  &.router-exact-link-active {
    pointer-events: none;
    cursor: default;
  }

  &--back {
    padding-left: 20px;
    background: url('/static/icons/back.svg') left center no-repeat;
  }

  &--bordered {
    border-bottom: 1px solid $color-gray-5;
  }
}
</style>
